/**
 * Algolia URL test parameter parser
 * Consolidates duplicate parseTestParams logic from 3 verification JS files.
 */

export interface AlgoliaTestParams {
  cacheEnabled: boolean;
  proxyPort: string | null;
}

/**
 * Parse URL query parameters for Algolia test/debug controls.
 *
 * - localStorage cache is ON by default（本番でレスポンスを再利用しリクエスト数を削減）。
 *   `?cache=off` で明示的に無効化できる（QA で素通し挙動を確認する用途）。
 *   旧 `?cache=on` も引き続き ON 扱い（後方互換）。
 * - `?proxy=PORT` — route via local proxy on given port
 */
export function parseTestParams(): AlgoliaTestParams {
  const params = new URLSearchParams(window.location.search);
  return {
    cacheEnabled: params.get('cache') !== 'off',
    proxyPort: params.get('proxy') || null,
  };
}
